<template>
  <div class="detail-content">
    <LittleBanner :attrName="examObj.examName" />
    <div class="detail-main">
      <div class="block-title">基本信息</div>
      <div class="block-content">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="block-item red-item">
              <div class="block-value">{{ examObj.jobCount }}</div>
              <div class="block-text">岗位</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="block-item blue-item">
              <div class="block-value">{{ examObj.userCount }}</div>
              <div class="block-text">招聘人数</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="block-item green-item">
              <div class="block-value" v-html="examObj.signupBeginTime"></div>
              <div class="block-text">报名时间</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="block-item purple-item">
              <div class="block-value">{{ examObj.chargeStatus }}</div>
              <div class="block-text">是否收费</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="block-title">岗位信息</div>
      <div class="block-content">
        <el-row :gutter="20" v-for="(arr, index) in jobs" :key="index">
          <el-col :span="8" v-for="(obj, index2) in arr" :key="index2">
            <div class="job-item">
              <div class="flex-container">
                <div>
                  <div class="job-name">{{ obj.jobName }}</div>
                  <div class="job-info">
                    <span v-if="obj.dept">部门：{{ obj.dept }}/</span>
                    <span v-if="obj.jobCount">人数：{{ obj.jobCount }}人</span>
                  </div>
                </div>
                <el-button type="primary" size="small" @click="examSign(obj.id)" class="sign-btn">立即报名</el-button>
              </div>
              <div class="job-require">
                <p>岗位要求：{{ obj.description }}</p>
                <p>性别要求：{{ obj.gender | filterGender }}</p>
                <p>年龄要求：{{ obj | filterAge }}</p>
                <p>学历要求：{{ obj.degree }}</p>
              </div>
              <div class="bottom-btn">
                <p>报名人数：{{ obj.signCount }}</p>
                <p>审核通过人数：{{ obj.passCount }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { examDetail, checkStatus } from '@/api/exam'
import LittleBanner from '../layout/components/LittleBanner'

export default {
  name: 'ExamDetail',
  data() {
    return {
      examId: null,
      jobs: [],
      examObj: {}
    }
  },
  filters: {
    filterGender: function(val) {
      if (val === '0') {
        return '不限'
      } else if (val === '1') {
        return '限男性'
      } else if (val === '2') {
        return '限女性'
      }
    },
    filterAge: function(obj) {
      return obj.ageMin + '~' + obj.ageMax + '岁'
    }
  },
  components: {
    LittleBanner
  },
  mounted() {
    this.examId = this.$route.query.id
    this.getData()
  },
  methods: {
    getData() {
      let that = this
      examDetail(this.examId)
        .then(res => {
          if (res.code === 200) {
            this.examObj = res.data
            this.jobs = []
            let rowLen = Math.ceil(res.data.jobs.length / 3)
            for (let i = 0; i < rowLen; i++) {
              this.jobs.push([])
            }
            this.examObj.jobs.forEach((element, index) => {
              let a = Math.floor(index / 3)
              that.jobs[a].push(element)
            });
            this.examObj.signupBeginTime = this.examObj.signupBeginTime.replace(' ', '<br>')
          }
        })
    },
    examSign(jobId) {
      checkStatus(jobId)
        .then(res => {
          if (res.code === 200) {
            if (res.data.status) {
              this.$router.push('/signUp?examId=' + this.examId + '&jobId=' + jobId)
            } else {
              this.$confirm('您已经报名过此考试，是否查看报名信息?', '提示')
                .then(() => {
                  this.$router.push('/user')
                })
            }
          }
        })
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-content {
  background: #f0f2f5;
  .bg-content {
    background: linear-gradient(135deg,#d262e3 0,#3f9ce8 100%);
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    .title {
      font-size: 14px;
    }
    .name {
      margin-top: 10px;
      font-size: 36px;
      font-weight: 700;
    }
  }
  .detail-header {
    background: #fff;
    border-bottom: 1px solid #e4e7ed;
    padding: 10px 0;
    .back-header {
      margin: 0 auto;
      max-width: 1200px;
    }
  }
  .detail-main {
    max-width: 1200px;
    margin: 0 auto;
    padding-bottom: 20px;
    .block-title {
      padding-top: 40px;
      margin-bottom: 25px;
      border-bottom: 1px solid #e4e7ed;
      font-size: 20px;
      line-height: 28px;
    }
    .block-content {
      text-align: center;
      .block-item {
        border-radius: 5px;
        background-size: cover;
        height: 160px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        .block-value {
          font-weight: 600;
          font-size: 36px;
        }
        .block-text {
          font-size: 16px;
          margin-top: 8px;
        }
      }
      .red-item {
        background-image: url('../../assets/bg-block1.png');
      }
      .blue-item {
        background-image: url('../../assets/bg-block2.png');
      }
      .green-item {
        background-image: url('../../assets/bg-block3.png');
      }
      .purple-item {
        background-image: url('../../assets/bg-block4.png');
      }
      .job-item {
        background: #fff;
        border-radius: 5px;
        text-align: left;
        margin-bottom: 10px;
        .flex-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #F7F7F7;
          padding: 15px;
          .sign-btn {
            flex-shrink: 0;
            width: 80px;
          }
        }
        .job-name {
          font-size: 16px;
          color: #141515;
          margin-bottom: 5px;
        }
        .job-info {
          font-size: 14px;
          color: #545454;
        }
        .job-require {
          padding: 7px 12px;
          color: #545454;
          font-size: 14px;
          min-height: 220px;
          p {
            margin: 8px 0;
          }
        }
        .bottom-btn {
          border-top: 1px solid #F7F7F7;
          color: #545454;
          font-size: 14px;
          padding: 7px 12px;
          p {
            line-height: 18px;
            margin: 8px 0;
          }
        }
      }
    }
  }
}
.bg-purple {
  background: #d3dce6;
}
</style>
